import _toConsumableArray from "D:/daima/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { onMounted, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useNewsStore } from "../../../store/news"; //引入news仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

export default {
  name: "NewsDetails",
  setup: function setup() {
    var store = useNewsStore();
    var router = useRouter();
    var route = useRoute();
    onMounted(function () {
      //通知vuex发送请求获取新闻推荐的数据
      store.getNewsRecommended();
    }); //数据
    //声明一个变量来接受新闻列表传过来的query参数包含 title、imgUrl、content、releaseDate 这四个参数

    var newsdetail = reactive({
      title: route.query.title,
      imgUrl: route.query.imgUrl,
      content: _toConsumableArray(JSON.parse(route.query.content)),
      releaseDate: route.query.releaseDate
    }); //接受新闻推荐的数据

    var _storeToRefs = storeToRefs(store),
        newsRecommended = _storeToRefs.newsRecommended; //方法
    //点击新闻推荐是修改页面数据


    function goRecommended(nr) {
      //滚动到详情位置.
      var goDetailTop = document.getElementById('long-left');
      goDetailTop.scrollIntoView({
        behavior: "smooth",
        //平滑滚动
        block: 'start' //将指定位置滚动到页面中间

      });
      newsdetail.title = nr.title;
      newsdetail.imgUrl = nr.bigImgUrl;
      newsdetail.content = nr.content;
      newsdetail.releaseDate = nr.releaseDate;
    } //跳转新闻列表


    function backNewsList() {
      router.push("/news");
    }

    return {
      newsdetail: newsdetail,
      newsRecommended: newsRecommended,
      goRecommended: goRecommended,
      backNewsList: backNewsList
    };
  }
};